/* Feedback around the native checkout submit; no cart or navigation replacement. */
const checkoutAttempts = new Map();

function resetCheckoutFeedback(form) {
  const attempt = checkoutAttempts.get(form);
  if (!attempt) return;
  const { button, label, spinner, originalLabel } = attempt;
  label.textContent = originalLabel;
  spinner.hidden = true;
  button.removeAttribute('aria-busy');
  checkoutAttempts.delete(form);
}

function resetAllCheckoutFeedback() {
  for (const form of checkoutAttempts.keys()) resetCheckoutFeedback(form);
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  const button = event.submitter;
  if (!(form instanceof HTMLFormElement) || !form.matches('form.cart-form')) return;
  if (!(button instanceof HTMLButtonElement) || !button.matches('[data-native-checkout]') || button.form !== form) return;
  if (event.defaultPrevented) return;

  // Only a previous, uncancelled native submit may suppress a duplicate.
  if (checkoutAttempts.get(form)?.confirmed) {
    event.preventDefault();
    return;
  }

  const label = button.querySelector('[data-checkout-label]');
  const spinner = button.querySelector('[data-checkout-spinner]');
  if (!label || !spinner) return;
  const attempt = { button, label, spinner, originalLabel: label.textContent, confirmed: false };
  checkoutAttempts.set(form, attempt);

  // App/theme submit listeners may still cancel this event later in propagation.
  // This microtask adds no timer or network gate to the native form submission.
  queueMicrotask(() => {
    if (checkoutAttempts.get(form) !== attempt) return;
    if (event.defaultPrevented || !form.isConnected || !button.isConnected) {
      resetCheckoutFeedback(form);
      return;
    }
    attempt.confirmed = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = button.dataset.checkoutPendingLabel;
    spinner.hidden = false;
  });
}, true);

// Validation normally happens before submit; also recover if validation is
// requested again by an integration while this document remains visible.
document.addEventListener('invalid', (event) => {
  const form = event.target?.form;
  if (form) resetCheckoutFeedback(form);
}, true);

// Restore a document reached via Back/Forward, including the bfcache copy.
window.addEventListener('pageshow', resetAllCheckoutFeedback);
// A cancelled unload or browser navigation must leave a usable native button.
window.addEventListener('beforeunload', (event) => {
  queueMicrotask(() => {
    if (event.defaultPrevented || event.returnValue) resetAllCheckoutFeedback();
  });
});
window.navigation?.addEventListener('navigateerror', resetAllCheckoutFeedback);
window.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') resetAllCheckoutFeedback();
});
